import { QR_CONFIG } from '~/config/qr'

const Welcome = () => import('~/pages/welcome.vue')
const NotFound = () => import('~/pages/errors/404.vue')
const Qr = () => import('~/pages/qr.vue')
const QrDisabled = () => import('~/pages/qr-disabled.vue')
const CampaignEnded = () => import('~/pages/campaign-ended.vue')
const CampaignCountdown = () => import('~/pages/campaign-countdown.vue')

export default [
  {
    path: '/',
    name: 'welcome',
    component: Welcome,
    meta: {
      requiresAuth: false,
      title: 'meta.welcome_title',
      description: 'meta.welcome_description',
      layout: 'default'
    }
  },
  {
    path: '/qr-disabled',
    name: 'qr-disabled',
    component: QrDisabled,
    meta: {
      requiresAuth: false,
      title: 'qr_scanning_disabled',
      description: 'qr_scanning_stay_tuned',
      layout: 'blank',
      skipGlobalLoading: true
    }
  },
  {
    path: '/campaign-ended',
    name: 'campaign-ended',
    component: CampaignEnded,
    meta: {
      requiresAuth: false,
      requiresCampaignCheck: true,
      title: 'campaign_ended',
      description: 'campaign_ended_message',
      layout: 'blank',
      skipGlobalLoading: true
    }
  },
  {
    path: '/campaign-countdown',
    name: 'campaign-countdown',
    component: CampaignCountdown,
    meta: {
      requiresAuth: false,
      requiresCampaignCheck: true,
      title: 'campaign_coming_soon',
      description: 'campaign_starts_in',
      layout: 'blank',
      skipGlobalLoading: true
    }
  },
  {
    path: '/:dynamicHash([A-Z0-9]{10})',
    name: 'qr-dynamic',
    component: Qr,
    meta: {
      requiresQR: true,
      title: 'meta.qr_title',
      description: 'meta.qr_description',
      layout: 'default',
      isDynamicQR: true
    }
  },
  {
    // Catch-all route for potential QR codes (realistic length range only)
    path: '/:invalidQR([A-Za-z0-9]{8,15})',
    name: 'invalid-qr',
    redirect: { name: 'welcome' },
    meta: {
      title: 'qr_not_found',
      description: 'meta.welcome_description'
    }
  },
  {
    // Final catch-all for any other unmatched routes
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: NotFound,
    meta: {
      title: 'meta.error_title',
      description: 'meta.error_description'
    }
  }
]
